import React, {useState} from "react";
import {useSelector} from "react-redux";
import ElementDropdownItem from "./ElementDropdownItem";

const AddElementButton = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const elements = useSelector(state => state.productDataReducer.product_elements);
    const displayElementSummary = useSelector(state => state.configuratorStateReducer.displayElementSummary);
    const currentElements = useSelector(state => state.productElementsReducer.elements_with_selections)
    const shapedAttributes = useSelector(state => state.productSelectionsReducer.shapedAttributes);

    if(shapedAttributes.length > 0) {
        return null
    }

    const handleClick = () => {
        setDropdownOpen(!dropdownOpen);
    }

    const getDropdownMenu = () => {
        if(!elements){
            return null;
        }
        const ordered = Object.assign([], elements).sort((a,b) => (a.order > b.order) ? 1 : -1)
        return ordered.map(el => <ElementDropdownItem key={el.name} text={el.name} element={el} onClick={() => handleClick()}/>);
    }

    const dropDownStyle = {
        position: 'absolute',
        top: 'calc(100% - 20px)',
        left: 0,
        border: '1px solid #FEDB00',
        borderRadius: '3px',
        cursor: 'pointer',
        zIndex: 999
    }

    // only show the button when there are NO elements - or all required steps of an element
    // have been completed.
    if(currentElements.length != 0 && !displayElementSummary){
        return null
    }

    return (
        <div style={{position:'relative', marginTop: '10px'}}>
            <div className='button' onClick={() => handleClick()}>Add Element</div>
            <div className='elements-dropdown' style={dropDownStyle} hidden={!dropdownOpen}>
                { getDropdownMenu() }
            </div>
        </div>
    )
}

export default AddElementButton;